import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import APIAMemberInformationForm from "webapp/components/Partner/APIA/APIAMemberInformationForm/APIAMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function APIAMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [showSelectError, setShowSelectError] = useState(false);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    devLog("onUserNext");

    if (!memberInfo || !selectedContact) {
      setShowSelectError(true);
    }

    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
    if (memberInfo && selectedContact) {
      devLog("onMemberNext", memberInfo?.name);
      props.context.setState(
        {
          accountRef: memberInfo?.accountRef,
          contactRef: selectedContact?.contactRef,
          Year: memberInfo.year,
          Make: memberInfo.make,
          Model: memberInfo.model,
          Color: memberInfo.color,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */

      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onUserSelectMember = (memberInfo, contact) => {
    devLog("onUserSelectMember", memberInfo, contact);
    setMemberInfo(memberInfo);
    setSelectedContact(contact);
    setShowSelectError(false);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("APIA.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <APIAMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onSelect={onUserSelectMember}
          showSelectError={showSelectError}
        />
      </div>

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}

export default APIAMemberInformation;
